import './NewsletterPage.style';
import newsletterBg from '../../../public/assets/images/bg-newsletter.png';

import { PureComponent } from 'react';

import CmsBlock from 'Component/CmsBlock';
import Newsletter from 'Component/Newsletter';
import Html from 'Component/Html';
import isMobile from 'Util/Mobile';
import Link from 'Component/Link';
import ExpandableContent from 'Component/ExpandableContent';
import Countdown from 'Component/Countdown';


export class NewsletterPage extends PureComponent {
    renderHeading() {
        const { promotion: { title}} = this.props;
        return <h1>{ title }</h1>;
    }

    renderContent() {
        const isNewsletterDiscountDisabled = this.props.newsletterConfig?.discount_disabled;

        const content = isNewsletterDiscountDisabled ? (<h2><Html content={ __('Subscribe to our Newsletter') }/></h2>) : (<h2><Html content={ __('Subscribe to our Newsletter and enjoy <strong>15% discount</strong> on your first order of <strong>60€</strong>.') } /></h2>);
        const cmsBlock = isNewsletterDiscountDisabled ? (<CmsBlock identifier="page-newsletter-no-discount" />) : (<CmsBlock identifier="page-newsletter" />);
        return (
            <div block="NewsletterPage" elem="Newsletter">
                <div block="NewsletterPage" elem="NewsletterContent">
                    { content }
                    <Newsletter showGdpr buttonText={ __('Subscribe') } />
                    { cmsBlock }
                </div>
            </div>
        )
    }

    renderBanner() {
        const { isLoading, promotion: { is_active, banner_image, banner_link } } = this.props;

        if (isLoading) {
            return (
                <div block="NewsletterPage" elem="Banner" mods={{ Loading: true }}></div>
            );
        }

        return (
            <div block="NewsletterPage" elem="Banner">
                <Link to={ banner_link }><img src={ banner_image } /></Link>
            </div>
        )
    }

    renderNewsletter() {
        const { promotion: { is_active } } = this.props;

        return (
            <div block="NewsletterPage" elem="Newsletter">
                <div block="NewsletterPage" elem="NewsletterContent">
                    <CmsBlock identifier="page-newsletter" />
                    <Newsletter button_text={ __('Subscribe') } source="miercuri" />
                </div>
            </div>
        )
    }

    renderConditions() {
        const { isLoading, promotion: { is_active, promotion_conditions, conditions_expanded } } = this.props;

        if (isLoading) {
            return null;
        }

        if (!is_active) {
            return null;
        }

        return (
            <div block="NewsletterPage" elem="ConditionsWrapper">
                <div block="NewsletterPage" elem="Conditions">
                    <ExpandableContent
                        heading={ __('Promotion conditions') }
                        isContentExpanded={ !!conditions_expanded }
                        mix={ {
                            block: 'NewsletterPageConditions'
                        } }
                    >
                        <Html content={ promotion_conditions } />
                    </ExpandableContent>
                </div>
            </div>
        );
    }

    renderProducts() {
        const { isLoading, promotion: { is_active, products_widget , title} } = this.props;

        if (isLoading) {
            return null;
        }

        if (!is_active) {
            return null;
        }

        return (
            <div block="NewsletterPage" elem="Products">
                { <Html content={ products_widget } /> }
            </div>
        )
    }

    render() {
        return (
            <div block="NewsletterPage">
                <div block="NewsletterPage" elem="Container">
                    { this.renderHeading() }
                    <div block="NewsletterPage" elem="Cols">
                        { this.renderBanner() }
                        { !isMobile.any() && this.renderContent() }
                    </div>
                </div>
                { isMobile.any() && this.renderContent() }
                { this.renderConditions() }
                { this.renderProducts() }
            </div>
        )
    }
}

export default NewsletterPage;
